import React from 'react'
import { useSelector } from '~/store/hooks'

import { connectSearchBox } from 'react-instantsearch-dom'

import trads from '~/intl/trads.json'

import { MagnifyingGlass } from '~/icons/MagnifyingGlass'

const Searchbox = ({ currentRefinement, refine }) => {
  const lang = useSelector((state) => state.lang)

  return (
    <form noValidate action="" role="search">
      <div className="labo-input text-white mt-6 md:mt-4">
        <label htmlFor="laboInput" className="labo-input__label bg-medium-green-2 font-semi-bold">
          {trads[lang].search.inputLabel1}
          <br />
          {trads[lang].search.inputLabel2}
        </label>
        <input
          id="laboInput"
          className="labo-input__input"
          type="search"
          onChange={(event) => refine(event.currentTarget.value)}
          placeholder={trads[lang].search.inputPlaceholder}
        />
        <button
          className="labo-input__button"
          onClick={(event) => event.preventDefault()}
        >
          <span className="sr-only">Search</span>

          <MagnifyingGlass className="icon-purple" width="24" height="24" />
        </button>
      </div>
    </form>
  )
}

const CustomSearchbox = connectSearchBox(Searchbox)

export default CustomSearchbox
